import {
  Headlines,
  LenderStatementHeadlines,
  StatementHeadlines,
  TCompanyId,
  TLenderId,
  TLoanId,
} from '/src/lib/models';
import { ISODateTimeString } from '/src/lib/types';

/**
 * Get Headlines
 */
export type TGetHeadlinesRequest = {
  companyId?: TCompanyId;
  loanId?: TLoanId;
  lenderId?: TLenderId;
};

export type TGetHeadlinesResponse = Headlines;

/**
 * Get Loan Statement Headlines
 */
export type TGetStatementHeadlinesRequest = {
  loanId: TLoanId;
  date: ISODateTimeString;
};

export type TGetStatementHeadlinesResponse = StatementHeadlines;

/**
 * Get Lender Statement Headlines
 */
export type TGetLenderStatementHeadlinesRequest = {
  companyId?: TCompanyId;
  loanId?: TLoanId;
  lenderId?: TLenderId;
  date?: ISODateTimeString;
};

export type TGetLenderStatementHeadlinesResponse = LenderStatementHeadlines;
